/*
 * @preserve
 * __VERSION_HERE__
 * */

import initShop from "../nike-shop/setup/initialize-nike-shop";
initShop();